"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _index = _interopRequireDefault(require("./index"));
var version = "v1";
var _default = exports["default"] = {
  get: function get(placeId, splitedAddress) {
    var url = "/".concat(version, "/addresses/").concat(placeId);
    if (splitedAddress) url += "?splited-address=1";
    return _index["default"].get(url);
  },
  place: function place(placeId) {
    return _index["default"].get("/".concat(version, "/place/").concat(placeId));
  },
  geocode: function geocode(_ref) {
    var latitude = _ref.latitude,
      longitude = _ref.longitude;
    return _index["default"].get("/".concat(version, "/addresses/geocode?latlng=").concat(latitude, ",").concat(longitude));
  },
  autocomplete: function autocomplete(params) {
    return _index["default"].get("/".concat(version, "/addresses/autocomplete"), {
      params: params
    });
  }
};